module.exports = __webpack_public_path__ + "img/source-icon.66ce7167.svg";